import { hasRule, espaceRPARules as rules } from "@/utils/rulesHelper"

function buildMenu() {
  let children = []

    children.push({ name: 'Accueil', url: '/suivi-cotisations/accueil', icon: 'icon-home' })
    children.push({ name: 'Suivi Règlements', url: '/suivi-cotisations/reglements', icon: 'fa fa-search' })
    if (hasRule(rules.ACCESS_SOLDES)) {
    	children.push({ name: 'Historique Solde', url: '/suivi-cotisations/soldes', icon: 'fa fa-history' })
    }
    children.push({ name: 'Historique Clotures', url: '/suivi-cotisations/clotures', icon: 'fa fa-history' })
    if (hasRule(rules.ACCESS_MOUVEMENTS)) {
    	children.push({ name: 'Mouvements Bred', url: '/suivi-cotisations/mouvements', icon: 'fa fa-euro' })
    }
    children.push({ name: 'Réf. IBAN SIREN', url: '/suivi-cotisations/iban-siren', icon: 'fa fa-euro' })
  return children
}
let menu = {
  items: buildMenu()
}
export default menu